import { Link } from 'react-router-dom';
import ShiftManager from '../app/Shift/ShiftManager';
import { useIntruderStore } from '@/store/intruderStore';
import { Roles, useRouteAccess } from '@/app/Roles/useRouteAccess';
import { navStore } from '@/store/navigationStore';
import { AppBreadcrumbs } from '@/components/navigation/AppBreadcrumbs';
import { CommandPaletteButton } from './CommandPaletteButton';
import { QuickNavigator } from './QuickNavigator';
import { FeedbackPopover } from './FeedbackPopover';

function Header() {
  const { hasRoleAccess } = useRouteAccess();
  const isLive = useIntruderStore((state) => state.isLive);
  const borderClass = isLive ? 'animate-border-pulse border-b-red-500 shadow-red-500/50' : '';

  return (
    <header
      data-onboarding="nav-bar"
      className={`sticky top-0 z-10 flex h-[3.5rem] w-full items-center border-b bg-[#111] transition-all ${borderClass} print:hidden`}
    >
      <div className="flex w-full items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="flex items-center">
            <button
              onClick={navStore.toggleNavigation}
              data-onboarding="nav-hamburger"
              className="flex h-[3.5rem] w-[3.5rem] items-center justify-center gap-2 border-r font-semibold hover:bg-lime/5 bg-transparent text-[#B7D257] cursor-pointer"
            >
              <img src="/icon/menu.svg" alt="menu" className="w-6" />
            </button>
            <Link to="/" className="flex h-[56px] cursor-pointer items-center pl-4 pr-2 gap-2">
              <img src="/icon/logo-lime.svg" alt="logo" className="h-5" />         
            </Link>
            <section className="hidden items-center gap-2 text-sm text-white/70 md:flex pr-2">
              <AppBreadcrumbs />
            </section>
  
          </div>
        </div>

        <div className="flex items-center max-md:hidden">
     
          {hasRoleAccess(Roles.Monitoring) && <CommandPaletteButton />}
          <QuickNavigator />
          {/* {watchfulOnlyFlag && <NotificationsSheet />} */}
          <div data-onboarding="nav-actions">
            <ShiftManager />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
